<template>
  <div class="view-profile-index">
    <app-content-title-back-home title="Мой профиль" />
    <div class="app-nav__tab">
      <button
        v-for="tab in $options.TABS"
        :key="tab.name"
        :class="[
          'app-nav__tab-item',
          { active: currentTab === tab.name, hidden: tab.hidden },
        ]"
        @click="currentTab = tab.name"
      >
        {{ tab.text }}
      </button>
    </div>
    <div class="app-nav__pane">
      <keep-alive>
        <component
          v-bind:is="currentTabComponent"
          class="app-nav__pane-item"
        ></component>
      </keep-alive>
    </div>

    <app-loader v-if="isLoading" isCircle isAbsolute></app-loader>
  </div>
</template>
<script>
export default {
  name: 'ViewProfileIndex',
  components: {
    AppContentTitleBackHome: () =>
      import('@/components/common/AppContentTitleBackHome.vue'),
    ProfileSettings: () =>
      import('@/pages/profile/components/ViewProfileSettings'),
    ProfileNotifications: () =>
      import('@/pages/profile/components/ViewProfileNotifications'),
    ProfileDigitalSignature: () =>
      import('@/pages/profile/components/ViewProfileDigitalSignature'),
    ProfileHistoryIp: () =>
      import('@/pages/profile/components/ViewProfileHistoryIp'),
    ProfileLoyaltyProgram: () =>
      import('@/pages/profile/components/ViewProfileLoyaltyProgram'),
    SvgIcon: () => import('@/components/common/AppSvgIcon.vue'),
    AppLoader: () => import('@/components/ui/AppLoader'),
  },
  data: () => ({
    isLoading: false,
    currentTab: 'profile-settings',
  }),
  computed: {
    currentTabComponent() {
      return this.currentTab;
    },
  },
  created() {
    this.$options.TABS = [
      { text: 'Настройки профиля', name: 'profile-settings', hidden: false },
      {
        text: 'Уведомления',
        name: 'profile-notifications',
        hidden: !this.$development,
      },
      {
        text: 'Цифровая подпись',
        name: 'profile-digital-signature',
        hidden: !this.$development,
      },
      { text: 'История IP', name: 'profile-history-ip', hidden: false },
      {
        text: 'Программа лояльности',
        name: 'profile-loyalty-program',
        hidden: !this.$development,
      },
    ];
  },
};
</script>

<style lang="scss">
.view-profile-index {
  &__title {
    margin-bottom: 20px;
  }
}

.view-profile-remove {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 30px 0 0;

  @include media-xs() {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0 30px;
  }

  &__text {
    margin: 0 30px 0 0;
    font-size: rem(10);
    line-height: 1.5;
    color: $color-black;
    text-align: right;
    opacity: 0.5;

    @include media-xs() {
      margin: 0 0 20px;
      text-align: left;
    }
  }

  &__link {
    display: flex;
    align-items: center;
    font-size: rem(13);
    line-height: 150%;
    color: $color-black;
    text-decoration: none;
    white-space: nowrap;
    opacity: 0.5;
    transition: opacity $A;

    &:hover {
      opacity: 1;
    }
  }

  &__icon {
    width: 30px;
    height: 30px;
    fill: $color-black;
  }
}

.app-nav {
  &__tab {
    display: flex;
    align-items: stretch;
    justify-content: flex-start;

    &-item {
      @include button-reset;

      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px 35px;
      margin: 0 10px 0 0;
      font-size: rem(11);
      line-height: 13px;
      color: #989898;
      text-align: center;
      text-transform: uppercase;
      letter-spacing: 0.02em;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      transition: all 0.2s linear;

      &:hover {
        color: $color-black;
        background: #eee;
      }

      &.active {
        color: $color-black;
        background: $color-white;
        border-color: $color-white;
      }

      &.hidden {
        display: none;
      }
    }
  }

  &__pane {
    position: relative;
    margin-top: -4px;

    &-item {
      padding: 40px;
      background: $color-white;
      border-radius: 2px;
    }
  }
}

@include media-sm() {
  .app-nav {
    &__tab {
      flex-wrap: nowrap;
      width: 100%;
      overflow: auto;

      &-item {
        padding: 15px 25px;
        margin: 0 10px 0 0;
        font-size: rem(10);
      }
    }
  }
}
</style>
